import React from 'react';
import { Box, Theme, makeStyles } from '@quillbot/design-system';
import { RootState } from 'src/_common/models/redux/store';
import { useSelector } from 'react-redux';
import CircularProgressWithLabel from 'src/_common/components/CircularProgressWithLabel';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
  loadingHolder: {
    width: '100%',
    maxWidth: '500px',
    margin: 'auto',
    height: '500px',
    position: 'absolute',
    top: '20vh',
    left: '0',
    right: '0',
    background: theme.palette.background.paper,
    opacity: 1,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'column',
  },
  loadingBar: {
    width: '200px',
    height: '200px',
  },
  roundedBox: {
    width: '160px',
    height: '160px',
    position: 'relative',
  },
  spanLock: {
    width: '160px',
    height: ' 160px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -27%)',
    display: 'block',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
}));

export default function LoadingLockHalf({ isLoading }: { isLoading: boolean }) {
  const isMobile = useSelector(
    (state: RootState) => state.common.platform.isMobile
  );
  const classes = useStyles();

  return isLoading ? (
    <div id="overlay" style={{ opacity: 1, background: 'rgba(0,0,0,0.6)' }}>
      <Box px={isMobile ? 1 : 3} style={{ height: '100%' }}>
        <Box className={classes.loadingHolder}>
          <CircularProgressWithLabel
            innerCircleVarient="indeterminate"
            value={50}
            containerClassName={classes.roundedBox}
            spanClassName={classes.spanLock}
            size={160}
            valuetext={
              <svg
                width="49"
                height="73"
                viewBox="0 0 49 73"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask id="path-1-inside-1" fill="white">
                  <rect
                    y="30.3504"
                    width="48.4941"
                    height="42.5256"
                    rx="2.98425"
                  />
                </mask>
                <rect
                  y="30.3504"
                  width="48.4941"
                  height="42.5256"
                  rx="2.98425"
                  stroke="#C2C2C2"
                  strokeWidth="7.46062"
                  mask="url(#path-1-inside-1)"
                />
                <path
                  d="M8.95276 31.0965V17.204C8.95276 8.80711 15.8002 2.00006 24.247 2.00006C32.6938 2.00006 39.5413 8.80711 39.5413 17.204V31.0965"
                  stroke="#C2C2C2"
                  strokeWidth="3.73031"
                />
                <path
                  d="M23.874 47.5098V55.7165"
                  stroke="#C2C2C2"
                  strokeWidth="3.73031"
                  strokeLinecap="round"
                />
              </svg>
            }
          />
          <i style={{ marginTop: '14px' }}>processing...</i>
        </Box>
      </Box>
    </div>
  ) : (
    <></>
  );
}